<template>
  <form @submit.prevent="submitForm" autocomplete="off" novalidate>
    <div class="row">
      <div class="col-md-2">
        <div class="user_img">
          <img v-if="item.profile_picture" :src="IMAGE_URL + item.profile_picture.key" alt="pic">
        </div>
        <div class="upload_user_profile text-center">
          <div v-if="item.profile_picture">
            <button type="button" class="mb-1 mt-1 me-1 btn btn-info mt-3" @click="removePicture">Remove</button>
          </div>
          <div v-else>
            <input type="file" ref="file" style="display: none;" @change="uploadFile" accept=".jpg,.jpeg"/>
            <button type="button" class="mb-1 mt-1 me-1 btn btn-info mt-3" @click="$refs.file.click()">Browse</button>
          </div>
        </div>
        <label for="profile_picture">Profile picture (Size should be 512x512 and jpeg,jpg in format allowed)</label>
      </div>
      
      <div class="col-md-5 event_detail_ls">
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Salutation *</div>
            <div class="col-md-8">
              <select class="form-control" @change="updateSalutation">
                <option value="Mr" :selected="item.salutation === 'Mr'">Mr</option>
                <option value="Mrs" :selected="item.salutation === 'Mrs'">Mrs</option>
              </select>
              <ValidationMessages :element="v$.item.salutation"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">First Name *</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="name" placeholder="Enter Name" :value="item.first_name" @input="updateFirstName">
              <ValidationMessages :element="v$.item.first_name"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Last Name</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="name" placeholder="Enter Name" :value="item.last_name" @input="updateLastName">
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Email *</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="name" placeholder="Enter Name" :value="item.email" @input="updateEmail">
              <ValidationMessages :element="v$.item.email"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Password</div>
            <div class="col-md-8">
              <input type="password" class="form-control" name="password" placeholder="Enter Password" @input="updatePassword"/>
              <small class="text-muted">Leave blank to keep current password</small>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Confirm Password</div>
            <div class="col-md-8">
              <input 
              type="password" class="form-control" name="cpassword" placeholder="Enter Confirm Password" :value="item.cpassword" @input="updateConfirmPassword"/>
              <ValidationMessages :element="v$.item.cpassword"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Facebook Profile</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="facebook_profile" placeholder="Enter Facebook Profile Link" :value="item.facebook_profile" @input="updateFacebookProfile"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Linkedin Profile</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="linkedin_profile" placeholder="Enter Linkedin Profile Link" :value="item.linkedin_profile" @input="updateLinkedinProfile"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Is Paid?</div>
            <div class="col-md-8">
              <input-switch name="is_paid" :value="item.is_paid" @change="changeIsPaid"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Status</div>
            <div class="col-md-8">
              <input-switch name="status" :value="item.status" @change="changeStatus"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Support User </div>
            <div class="col-md-8">
              <input-switch name="support_user" :value="item.support_user" @change="changeSupportUser"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Personal profile</div>
            <div class="col-md-8">
              <textarea rows="3" class="form-control" name="biography" placeholder="Enter profile description" :value="item.biography" @input="updateBiography"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-5 event_detail_wrapper">
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Company</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="company" placeholder="Enter Company" :value="item.company_name" @input="updateCompany"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Job Title</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="company" placeholder="Enter Job title" :value="item.job_title" @input="updateJobTitle"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Phone</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="company" placeholder="Enter Phone number" :value="item.Phone" @input="updatePhone"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Country Code</div>
            <div class="col-md-8">
              <select class="form-control" @change="updateCountryCode">
                <option value="" selected>Select</option>
                <option v-for="option in countryCodesAll" :value="option.id" :key="option.id"
                  :selected="(item.country_code == option.id)">
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Allow notification</div>
            <div class="col-md-8">
              <input-switch name="allow_notification" :value="item.allow_notification" @change="changeAllowNotification"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Porfolio Link</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="portfolio_link" placeholder="Portfolio Link" :value="item.portfolio_link" @input="updatePortfolioLink"/>
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Twitter Link</div>
            <div class="col-md-8">
              <input type="text" class="form-control" name="portfolio_link" placeholder="Twitter Link" :value="item.twitter_profile" @input="updateTwitterLink"/>
            </div>
          </div>
        </div>

        <!-- Updated Match Making Keywords Field with Dropdown -->
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="event_ls_label col-md-2">Match Making Keywords</div>
            <div class="col-md-8">
              <div class="keywords-container">
                <!-- Selected Keywords Display -->
                <div class="selected-keywords" v-if="localKeywordsArray.length > 0">
                  <span v-for="(keyword, index) in localKeywordsArray" :key="index" class="keyword-tag">
                    {{ keyword }}
                    <button type="button" class="remove-keyword" @click="removeKeyword(index)">×</button>
                  </span>
                </div>
                
                <!-- Dropdown for Adding Keywords -->
                <div class="keyword-select-wrapper">
                  <select 
                    class="form-control keyword-dropdown" 
                    v-model="selectedKeyword"
                    @change="addKeywordFromDropdown"
                    :disabled="loadingEventKeywords || !allEventKeywords || allEventKeywords.length === 0"
                  >
                    <option value="">-- Select a keyword to add --</option>
                    <option 
                      v-for="keyword in availableKeywords" 
                      :key="keyword" 
                      :value="keyword"
                    >
                      {{ keyword }}
                    </option>
                  </select>
                  
                  <!-- Loading State -->
                  <div v-if="loadingEventKeywords" class="loading-spinner">
                    <i class="fa fa-spinner fa-spin"></i> Loading keywords...
                  </div>
                  
                  <!-- No Keywords Message -->
                  <div v-if="!loadingEventKeywords && allEventKeywords && allEventKeywords.length === 0" class="text-muted mt-2">
                    No match making keywords available. Please add keywords to the event first.
                  </div>
                  
                  <!-- All Keywords Added Message -->
                  <div v-if="!loadingEventKeywords && allEventKeywords && allEventKeywords.length > 0 && availableKeywords.length === 0 && localKeywordsArray.length > 0" class="text-success mt-2">
                    <i class="fa fa-check-circle"></i> All available keywords have been added!
                  </div>
                </div>
                
                <small class="text-muted">Select keywords from the dropdown to help match this user with relevant content. Keywords are case-insensitive.</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="text-right mt-3 mr-5">
        <button type="submit" class="mb-1 mt-1 me-1 btn btn-lg btn-primary">Save</button>
        <button type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-secondary" @click="cancelClick">Cancel</button>
      </div>
    </div>
    <FlashMessage group="user_edit"/>
  </form>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import _ from "lodash";
import {
    useVuelidate
} from '@vuelidate/core'
import {
    required,
    email,
} from '@vuelidate/validators'
import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import { upload, remove } from "@/services/FileUploader";
import ObjectID from 'bson-objectid';
import constants from "@/config/constants";
import InputSwitch from "@/components/Commons/InputSwitch";

export default {
  name: 'UserEditForm',
  data() {
    return {
      IMAGE_URL: constants.IMAGE_URL,
      localKeywordsArray: [], // Local copy to avoid direct Vuex mutation
      selectedKeyword: '',
      keywordsFetched: false
    }
  },
  components: {
    InputSwitch,
    ValidationMessages
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return {
      item: {
        salutation: {
          required,
        },
        first_name: {
          required,
        },
        email: {
          required,
          email
        },
        cpassword: {
          // Only validate if password is provided
          sameAsPassword: (value) => {
            if (!this.item.password) return true;
            return value === this.item.password;
          }
        }
      }
    };
  },
  props: {
    id: [String, null]
  },
  watch: {
    id: {
      handler(value) {
        if (value) {
          this.loadUserData();
        }
      },
      immediate: true
    },
    // Sync from store to local when store changes
    'item.user_keywords': {
        handler(newKeywords) {
            if (newKeywords && Array.isArray(newKeywords)) {
                const newArray = [...newKeywords];
                if (JSON.stringify(this.localKeywordsArray) !== JSON.stringify(newArray)) {
                    console.log("Store keywords changed, syncing to local");
                    this.localKeywordsArray = newArray;
                }
            } else if (!newKeywords && this.localKeywordsArray.length > 0) {
                this.localKeywordsArray = [];
            }
        },
        deep: true,
        immediate: true
    },
    
    eventId: {
      handler(newEventId) {
        if (newEventId && !this.keywordsFetched) {
          this.fetchAllEventKeywords();
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('EventUsersSingle', ['item', 'loading', "is_editing", "is_new", 'user_typeEnum']),
    ...mapGetters('EventUsersIndex', ['countryCodesAll']),
    ...mapGetters("EventKeywordsIndex", {
        allEventKeywords: 'item',
        loadingEventKeywords: 'loading'
    }),
    
    eventId() {
        return this.$route.params.event_id;
    },
    
    // Get available keywords (not already added) - case-insensitive
    availableKeywords() {
        if (!this.allEventKeywords || !Array.isArray(this.allEventKeywords)) return [];
        return this.allEventKeywords.filter(keyword => 
            !this.isKeywordAdded(keyword)
        );
    }
  },
  created() {
    // Don't fetch here, let watchers handle it
  },
  
  beforeUnmount() {
    delete this.$flashMessage.groups.user_edit;
    this.resetState();
  },
  
  methods: {
    ...mapActions('EventUsersIndex', {
      fetchAllData: 'fetchData'
    }),
    ...mapActions('EventUsersSingle', [
      'fetchData',
      'updateData',
      'resetState',
      'setFirstName',
      'setLastName',
      'setCompany',
      'setEmail',
      'setPassword',
      'setSalutation',
      'setPicture',
      'setJobTitle',
      'setPhone',
      'setCountry',
      'setAllowNotification',
      'setFacebookProfile',
      'setLinkedinProfile',
      'setPortfolioLink',
      'setTwitterProfile',
      'setIsPaid',
      'setStatus',
      "setUser_type",
      "setEvents",
      "setCountryCode",
      "setBiography",
      'setUpdateConfirmPassword',
      'setSupportUser',
      'setKeywords',
      'updateItemField'
    ]),
    ...mapActions("EventKeywordsIndex", ['fetchData']),
    
    /**
     * Load user data
     */
    async loadUserData() {
      try {
       // await this.fetchData(this.id);
        
        if (this.item.user_keywords && Array.isArray(this.item.user_keywords)) {
          this.localKeywordsArray = [...this.item.user_keywords];
          console.log("Initial keywords from loaded data:", this.localKeywordsArray);
        }
        
        // Set support user status
        this.setSupportUser(false);
        let eventId = this.$route.params.event_id;
        const event_user = _.find(this.item.events, i => i.event_id === eventId);
        let currentEventRole = _.get(event_user, 'role', '');
        if(currentEventRole === 'Support'){
          this.setSupportUser(true);
        }
      } catch (error) {
        console.error("Error loading user data:", error);
        this.$flashMessage.show({
          group: 'user_edit',
          type: 'error',
          title: 'Error',
          text: 'Something went wrong.'
        });
      }
    },
    
    /**
     * Fetch all event keywords
     */
    async fetchAllEventKeywords() {
      if (!this.eventId) {
        console.warn("Cannot fetch keywords: eventId is undefined");
        return;
      }
      
      try {
        console.log("Fetching keywords for event:", this.eventId);
        await this.fetchData({ event_id: this.eventId });
        this.keywordsFetched = true;
        console.log("Keywords fetched successfully:", this.allEventKeywords);
      } catch (error) {
        console.error('Error fetching event keywords:', error);
        this.$flashMessage.show({
          group: 'user_edit',
          type: 'error',
          title: 'Error',
          time: 3000,
          html: '<ul><li>Failed to load match making keywords</li></ul>'
        });
      }
    },
    
    /**
     * Normalize keyword to lowercase for comparison
     */
    normalizeKeyword(keyword) {
        return keyword ? keyword.toLowerCase().trim() : '';
    },
    
    /**
     * Check if keyword is already added (case-insensitive)
     */
    isKeywordAdded(keyword) {
        const normalizedKeyword = this.normalizeKeyword(keyword);
        return this.localKeywordsArray.some(k => this.normalizeKeyword(k) === normalizedKeyword);
    },
    
    /**
     * Add keyword from dropdown
     */
    addKeywordFromDropdown() {
      if (!this.selectedKeyword) return;
      
      // Prevent adding if already exists
      if (this.isKeywordAdded(this.selectedKeyword)) {
        this.$flashMessage.show({
          group: 'user_edit',
          type: 'error',
          title: 'Error',
          time: 1500,
          html: '<ul><li>Keyword already exists!</li></ul>'
        });
        this.selectedKeyword = '';
        return;
      }
      
      // Update local array first
      const newKeywords = [...this.localKeywordsArray, this.selectedKeyword];
      this.localKeywordsArray = newKeywords;
      
      // Then update store through mutation
      this.setKeywords(newKeywords);
      
      // Show success message
      this.$flashMessage.show({
        group: 'user_edit',
        type: 'success',
        title: 'Success',
        time: 1500,
        html: '<ul><li>Keyword added successfully</li></ul>'
      });
      
      // Reset selection
      this.selectedKeyword = '';
    },
    
    /**
     * Remove keyword from array
     */
    removeKeyword(index) {
        // Update local array first
        const newKeywords = [...this.localKeywordsArray];
        newKeywords.splice(index, 1);
        this.localKeywordsArray = newKeywords;
        
        // Then update store through mutation
        this.setKeywords(newKeywords);
        
        this.$flashMessage.show({
            group: 'user_edit',
            type: 'success',
            title: 'Success',
            time: 1500,
            html: '<ul><li>Keyword removed successfully</li></ul>'
        });
    },
    
    gettingErrorMessage(error){
      let html = "Something went wrong";
      if(error && error.response && error.response.data && error.response.data.data && error.response.data.data.error){
        let errors = error.response.data.data.error;
        html = "<ul>"
        for(let err of errors){
          html+= "<li>"+err.message+"</li>";
        }
        html+="</ul>";
      }
      return html;
    },
    
    changeSupportUser(e){
      this.setSupportUser(e.target.checked);
    },
    
    updateSalutation(e) {
      this.setSalutation(e.target.value);
    },
    
    updateFirstName(e) {
      this.setFirstName(e.target.value);
    },
    
    updateLastName(e) {
      this.setLastName(e.target.value);
    },
    
    updateEmail(e) {
      this.setEmail(e.target.value);
    },
    
    updatePassword(e) {
      this.setPassword(e.target.value);
    },
    
    updateCompany(e) {
      this.setCompany(e.target.value);
    },
    
    updateJobTitle(e) {
      this.setJobTitle(e.target.value);
    },
    
    updatePhone(e) {
      this.setPhone(e.target.value);
    },
    
    updateCountry(e) {
      this.setCountry(e.target.value);
    },
    
    updateCountryCode(e){
      console.log(e.target.value)
      this.setCountryCode(e.target.value);
    },
    
    updateBiography(e){
      this.setBiography(e.target.value);
    },
    
    async uploadFile(e) {
      try {
        const file = e.target.files[0];
        const id = ObjectID();
        const resp = await upload(file, id, "event-users", "512X512", 'user_logo');
        if(resp.response && resp.response.data.status === "FAILED"){
          this.$flashMessage.show({
            group : 'user_edit',
            type  : 'error',
            title : 'Error',
            time  : 1000,
            html  : "<ul><li>Invalid File/Doc format.Please use described valid format.</li></ul>"
          });
          return;
        }
        let extension = resp.data.data.key.split('.').pop();
        if(!(extension === "jpg" || extension === "jpeg")){
          this.$flashMessage.show({
            group : 'user_edit',
            type  : 'error',
            title : 'Error',
            time  :1000,
            html  : "<ul><li>Invalid File/Doc format.Please use described valid format.</li></ul>"
          });
          return;
        }
        this.setPicture(resp.data.data);
      } catch (e) {
        this.$flashMessage.show({
          group: 'user_edit',
          type: 'error',
          title: 'Error',
          text: 'Something went wrong.'
        });
      }
    },
    
    removePicture() {
      this.$swal({
        title: 'Are you sure?',
        text: "To fully delete the file submit the form.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#dd4b39',
        focusCancel: true,
        reverseButtons: true
      }).then(result => {
        if (typeof result.dismiss === "undefined") {
          remove(this.item.profile_picture.key).then(() => {
            this.setPicture(null);
          })
        }
      })
    },
    
    changeIsPaid(e) {
      this.setIsPaid(e.target.checked);
    },
    
    changeStatus(e) {
      this.setStatus(e.target.checked)
    },
    
    changeAllowNotification(e) {
      this.setAllowNotification(e.target.checked)
    },
    
    updateFacebookProfile(e) {
      this.setFacebookProfile(e.target.value);
    },
    
    updateLinkedinProfile(e) {
      this.setLinkedinProfile(e.target.value);
    },
    
    updatePortfolioLink(e) {
      this.setPortfolioLink(e.target.value);
    },
    
    updateTwitterLink(e) {
      this.setTwitterProfile(e.target.value);
    },
    
    updateConfirmPassword(e){
      this.setUpdateConfirmPassword(e.target.value)
    },
    
    checkPwd(str) {
      if (!str) return "ok"; // Allow empty password (keep current)
      if (str.length < 6) {
        return "Password is too short. It should be at least 6 characters.";
      } else if (str.length > 50) {
        return "Password is too long. It should be no more than 50 characters.";
      } else if (str.search(/\d/) === -1) {
        return "Password must contain at least one number.";
      } else if (str.search(/[a-zA-Z]/) === -1) {
        return "Password must contain at least one letter.";
      } else if (str.search(/[!@#$%^&*()_+]/) === -1) {
        return "Password must contain at least one special character (e.g., !@#$%^&*).";
      } else if (str.search(/[^a-zA-Z0-9!@#$%^&*()_+]/) !== -1) {
        return "Password contains invalid characters.";
      }
      return "ok"; 
    },
    
    async submitForm() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return
      
      console.log("SUBMIT FORM - Current keywords in store BEFORE sync:", this.item.user_keywords);
      console.log("SUBMIT FORM - Current localKeywordsArray:", this.localKeywordsArray);
      
      // Ensure keywords are synced before saving
      const storeKeywords = Array.isArray(this.item.user_keywords) ? [...this.item.user_keywords] : [];
      const localKeywords = [...this.localKeywordsArray];
      
      console.log("Store keywords as array:", storeKeywords);
      console.log("Local keywords as array:", localKeywords);
      
      // Sync if needed
      if (JSON.stringify(storeKeywords) !== JSON.stringify(localKeywords)) {
          console.log("Keywords mismatch - syncing to store");
          await this.setKeywords(localKeywords);
          await this.$nextTick();
      }
      
      console.log("After sync - keywords in store:", this.item.user_keywords);
      console.log("After sync - localKeywordsArray:", this.localKeywordsArray);
      
      // Password validation (only if password is provided)
      if(this.item.password && this.item.password.trim() !== ''){
          let resp = this.checkPwd(this.item.password)
          if(resp !== 'ok'){
              this.$flashMessage.show({
                  group : 'user_edit',
                  type  : 'error',
                  title : 'Error',
                  time  : 1300,
                  html  : "<ul><li>" + resp + "</li></ul>"
              });
              return;  
          }
          
          if(this.item.password !== this.item.cpassword){
              this.$flashMessage.show({
                  group : 'user_edit',
                  type  : 'error',
                  title : 'Error',
                  time  : 1000,
                  html  : "<ul><li>Confirm Password does not match with Password</li></ul>"
              });
              return;
          }
      }
      
      console.log("Submitting with keywords:", this.item.user_keywords);
      
      this.updateData(this.$route.params.event_id)
          .then(() => {
              this.$flashMessage.show({
                  group : 'event_users',
                  type  : 'success',
                  title : 'Success',
                  time  : 1000,
                  html  : '<ul><li>Event user updated successfully.</li></ul>'
              });
              this.resetState();
              this.fetchAllData(this.$route.params.event_id);
          })
          .catch((error) => {
              console.error(error)
              let html = this.gettingErrorMessage(error);
              this.$flashMessage.show({
                  group : 'user_edit',
                  type  : 'error',
                  title : 'Error',
                  time  : 1000,
                  text  : html,
                  html  : html
              });
          })
    },
    
    cancelClick() {
      this.resetState();
      this.localKeywordsArray = [];
      this.selectedKeyword = '';
    }
  }
}
</script>

<style lang="scss" scoped>
.user_img {
    img {
        width: 100%;
    }
}

.event_detail_wrapper {
    padding: 10px 0px;

    .event_ls_label {
        font-weight: bold;
    }

    .row {
        .col-md-8 {
            border-bottom: 1px dotted #ccc;
            padding-bottom: 5px;
        }

        .col-md-3 {
            border-bottom: 1px dotted #ccc;
            padding-bottom: 5px;
        }
    }

    .card-body {
        box-shadow: 0px 0px #ffffff;
    }
}

/* Keywords Styles */
.keywords-container {
  .selected-keywords {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
    
    .keyword-tag {
      background-color: #0088CC;
      color: white;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 0.875rem;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      
      .remove-keyword {
        background: none;
        border: none;
        color: white;
        cursor: pointer;
        font-size: 1.2rem;
        line-height: 1;
        padding: 0;
        width: 18px;
        height: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }
      }
    }
  }
  
  .keyword-select-wrapper {
    .keyword-dropdown {
      border-radius: 4px;
      
      &:focus {
        border-color: #0088CC;
        box-shadow: 0 0 0 0.2rem rgba(0, 136, 204, 0.25);
      }
      
      &:disabled {
        background-color: #e9ecef;
        cursor: not-allowed;
      }
    }
    
    .loading-spinner {
      margin-top: 8px;
      color: #0088CC;
      font-size: 0.875rem;
      
      i {
        margin-right: 6px;
      }
    }
  }
}

@media (max-width: 768px) {
  .keywords-container {
    .selected-keywords {
      .keyword-tag {
        font-size: 0.75rem;
        padding: 2px 6px;
      }
    }
  }
}
</style>